export default "__VITE_ASSET__fd713d3e__"